import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { Layout } from '../../models/pages';

import LoadingIcon from '../Icons/LoadingIcon';
import SectionComponent from './SectionComponent';

import './style/_layout.scss';

const allActionCreators = Object.assign({});

export class LayoutComponent extends Component {

  getLayoutModel() {
    return this.props.layout || new Layout();
  }

  render() {
    return <div className={'LayoutComponent'}>
      <div className='layoutLiner'>
        {this.props.load === false ?
          <div className='layoutLoading'>
            <div className='loadingIconWrapper'>
              <LoadingIcon />
            </div>
          </div> :
          <>
            {this.getLayoutModel().sections.map((section, i) => {
              return <div key={i} className='layoutComponentWrapper'>
                <SectionComponent
                  section={section} />
              </div>;
            })}
          </>
        }
      </div>
    </div>;
  }
}

function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(LayoutComponent));